<script setup lang="ts">
  import { ref } from 'vue'
  import { onClickOutside } from '@vueuse/core'
  import { usePresentationsMenuStore } from '@/stores/list-item-menu'
  import { usePresentationsStore } from '@/stores/presentations'
  import { usePopupStore } from '@/stores/popup'
  import { useUpgradeStore } from '@/stores/upgrade'
  import { useUserStore } from '@/stores/user'
  import { requiredPlanForBookFormat } from '@/helpers/product'
  import DesMenuOptions from '@/components/menu/DesMenuOptions.vue'
  import DesMenuItem from '@/components/menu/DesMenuItem.vue'

  const menu = usePresentationsMenuStore()
  const presentations = usePresentationsStore()
  const popup = usePopupStore()
  const upgrade = useUpgradeStore()
  const user = useUserStore()

  const target = ref<HTMLElement | null>(null)

  onClickOutside(target, () => menu.item && menu.close())

  const duplicate = async () => {
    if (!user.canCreatePresentations()) {
      upgrade.showUpgradeModal('presentation-create', requiredPlanForBookFormat('presentation'))

      return
    }

    if (menu.item) await presentations.duplicate(menu.item.id)
  }

  const remove = async () => {
    const result = await popup.confirm('Are you sure you want to delete this presentation?', {
      content: 'This action is irreversible.',
      labelConfirm: 'Delete',
    })

    if (result === true && menu.item) await presentations.remove(menu.item.id)
  }
</script>

<template>
  <div
    class="absolute z-50"
    :style="{ left: menu.position.left + 'px', top: menu.position.top + 'px' }"
    ref="target"
    @click="menu.close()"
  >
    <DesMenuOptions :open="menu.opened" :left="menu.flip" :right="!menu.flip">
      <DesMenuItem
        @click="() => duplicate()"
        icon="fa-light fa-copy"
        :unlocked-for="user.canCreatePresentations() ? undefined : requiredPlanForBookFormat('presentation')"
      >
        Duplicate
      </DesMenuItem>
      <DesMenuItem @click="() => remove()" icon="fa-light fa-trash-can" danger>Delete</DesMenuItem>
    </DesMenuOptions>
  </div>
</template>
